import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class ActionService {
  messageSource;
  currentMessage;

  valueJSONMessageSource;
  valueJSONMessage;


  constructor() {
    this.messageSource = new BehaviorSubject<any>(undefined);
    this.currentMessage = this.messageSource.asObservable();

    this.valueJSONMessageSource = new BehaviorSubject<any>(undefined);
    this.valueJSONMessage = this.valueJSONMessageSource.asObservable();
  }

  triggerAction(data: any) {
    this.messageSource.next(data);
  }

  triggerValueJSONUpdate(data: any) {
    this.valueJSONMessageSource.next(data);
  }
}
